import FlexContainerBase from './_flex-container-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurablePosition from './_configurable-position.js'

export default {
  name: 'AbsolutePane',
  values: {
    fixed: false,
    style: {
      width: undefined,
      height: undefined,
      zIndex: undefined,
      pointerEvents: undefined,
      overflow: undefined,
      $mixin: [
        {
          configSet: FlexContainerBase,
        },
        {
          configSet: ConfigurablePane,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
        {
          configSet: ConfigurablePosition,
        },
      ],
    },
  },
  meta: {
    extendable: false,
  },
}
